export default __webpack_public_path__ + "static/11-e375a9bcb63989156d6a24dfaba98816.webp";